<tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.REQUIREMENTS' | translate">
    @if (hasRequirementsContent) {
        @for (doc of docsData?.document; track $index) {
            <tec-item
                [classes]="['item--outline']"
                [tagImage]="{ icon: 'icon-list-ticks', status: 'simple' }"
                [tagIcon]="getTagIconItem(doc?.state)"
                [title]="'PROCESSES.DETAIL.DOCUMENT_TYPE' | translate"
                [clickeable]="false"
            >
                <tec-list-detail>
                    <span>{{ documentTypeLabel(doc) }}</span>
                </tec-list-detail>
            </tec-item>
        }
    } @else {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    }
</tec-tile>

<tec-tile [title]="'OPERATIONS.DETAIL.TABS.CHECKS.COMPARE_INFO' | translate">
    @if (hasCompareContent && checksDetailCompare) {
        <app-operation-documents-checks-compare-info [checksDetail]="checksDetailCompare" />
    } @else {
        <tec-empty-state [title]="'OPERATIONS.DETAIL.TABS.CHECKS.EMPTY' | translate" [size]="'default'" [type]="'empty'" />
    }
</tec-tile>
